import { forwardRef, useCallback, useMemo, Ref, Fragment } from 'react';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { cx } from '@utils';
import styles from './style/Breadcrumbs.css';

type BreadcrumbProps = {
  className?: string;
} & ChildrenProps;

export const Breadcrumb = forwardRef(({ children, className }: BreadcrumbProps, ref: Ref<HTMLDivElement>) => {

  return (
    <div ref={ref} className={cx(styles.crumb, className)}>
      {children}
    </div>
  );
});

type BreadcrumbsProps = {
  className?: string;
  children: React.ReactNode[];
};

export const Breadcrumbs = ({ children, className }: BreadcrumbsProps) => {

  const filteredChildren = useMemo(() => children.filter(Boolean), [children]);

  const renderChild = useCallback((child: React.ReactNode, i: number) => {
    return (
      <Fragment key={i}>
        {child}
        {i !== filteredChildren.length - 1 && <ChevronRight className={styles.separator} />}
      </Fragment>
    );
  }, [filteredChildren]);

  return (
    <div className={cx(styles.root, className)}>
      {filteredChildren.map(renderChild)}
    </div>
  );
};